export enum SignStatus {
  SIGNED = 'signed',
  PENDING = 'pending',
  IN_PROGRESS = 'in-progress',
  ON_HOLD = 'on-hold',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  OBSOLETE = 'obsolete'
}
